import React, { useState } from 'react';
import ProfileDropdown from './profileDropDown';

export default function NavBar({ isAuthenticated, currentView, onNavigate, onLogout }) {

  const [showUploadMenu, setShowUploadMenu] = useState(false);

    const navButton = (label, view, style = '') => (
      currentView !== view && (
        <a
          onClick={() => onNavigate(view)}
          className={`cursor-pointer ${style}`}
        >
          {label}
        </a>
      )
    );
  
    return (
      <header className="w-full px-6 py-4 flex justify-between items-center shadow-md bg-white fixed top-0 z-50">
        <div className="text-xl font-bold cursor-pointer" onClick={() => {
          if(isAuthenticated == true){
            onNavigate('dashboard');
          }else{
            onNavigate('home');
          }
          }}>
          poppyruz
        </div>
  
        <nav className="flex items-center space-x-6">
          {isAuthenticated ? (
            <>
              <div
                className="relative"
                onMouseEnter={() => setShowUploadMenu(true)}
                onMouseLeave={() => setShowUploadMenu(false)}
              >
                <button className="bg-orange-600 text-white px-4 py-2 rounded hover:bg-orange-700">
                  Upload
                </button>

                {showUploadMenu && (
                  <div className="absolute left-0 top-full w-44 bg-white border rounded shadow z-50">
                    <div
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                      onClick={() => {
                        setShowUploadMenu(false);
                        onNavigate('upload');
                      }}
                    >
                      Upload Book
                    </div>
                    <div
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                      onClick={() => {
                        setShowUploadMenu(false);
                        onNavigate('upload_theme');
                      }}
                    >
                      Upload Theme
                    </div>
                  </div>
                )}
              </div>
              {navButton('Dashboard', 'dashboard', 'hover:text-blue-600')}
              {navButton('My Books', 'my_books', 'hover:text-blue-600')}
              {navButton('Public Books', 'books', 'hover:text-blue-600')}
              <div className="w-10 h-10 flex items-center cursor-pointer">
                <ProfileDropdown onLogout={onLogout} />
              </div>
            </>
          ) : (
            <>
              {navButton('Home', 'home', 'hover:text-blue-600')}
              {navButton('Books', 'books', 'hover:text-blue-600')}
              {currentView === 'login'
                ? navButton('Sign Up', 'signup', 'bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700')
                : navButton('Upload', 'upload', 'bg-orange-600 text-white px-4 py-2 rounded hover:bg-orange-700')
              }
              {navButton('Login', 'login', 'bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700')}
            </>
          )}
        </nav>
      </header>
    );
  }
  